import React from 'react';
import { Phone, FileText, Download, ExternalLink, AlertCircle } from 'lucide-react';
export function RegistrationLicensingFormsPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-3327">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-3328">
        <div className="container mx-auto px-4" data-id="element-3329">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-3330">
            Registration & Licensing Forms
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-3331">
            FMCSA Required Forms & Applications
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-3332">
        <div className="max-w-5xl mx-auto" data-id="element-3333">
          {/* Online Submission Notice */}
          <div className="bg-blue-50 border-2 border-blue-500 rounded-lg shadow-md p-6 mb-8" data-id="element-3334">
            <div className="flex items-start" data-id="element-3335">
              <AlertCircle className="text-blue-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-3336" />
              <div data-id="element-3337">
                <p className="text-gray-800" data-id="element-3338">
                  The following are printable Registration and Licensing forms,
                  however,{' '}
                  <strong data-id="element-3339">
                    FMCSA strongly encourages users to{' '}
                    <a href="http://www.fmcsa.dot.gov/registration-licensing/online-registration/onlineregdescription.htm" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline font-bold" data-id="element-3340">
                      submit these forms online
                    </a>
                  </strong>
                  .
                </p>
              </div>
            </div>
          </div>

          {/* USDOT Number Forms */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3341">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3342">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3343" />
              USDOT Number
            </h2>

            <div className="space-y-3" data-id="element-3344">
              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/MCS-150-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-blue-50 hover:bg-blue-100 border-2 border-blue-200 rounded-lg p-4 transition-colors group" data-id="element-3345">
                <div className="flex items-center flex-1" data-id="element-3346">
                  <div className="bg-blue-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3347">
                    MCS-150
                  </div>
                  <div className="flex-1" data-id="element-3348">
                    <p className="font-semibold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-3349">
                      Motor Carrier Identification Report
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-3350">
                      Application for USDOT Number
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3351">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-blue-600 ml-4 flex-shrink-0" size={20} data-id="element-3352" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/MCS-150A-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-green-50 hover:bg-green-100 border-2 border-green-200 rounded-lg p-4 transition-colors group" data-id="element-3353">
                <div className="flex items-center flex-1" data-id="element-3354">
                  <div className="bg-green-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3355">
                    MCS-150A
                  </div>
                  <div className="flex-1" data-id="element-3356">
                    <p className="font-semibold text-gray-900 group-hover:text-green-600 transition-colors" data-id="element-3357">
                      Safety Certification for Application for USDOT Number
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3358">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-green-600 ml-4 flex-shrink-0" size={20} data-id="element-3359" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/MCS-150B-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-purple-50 hover:bg-purple-100 border-2 border-purple-200 rounded-lg p-4 transition-colors group" data-id="element-3360">
                <div className="flex items-center flex-1" data-id="element-3361">
                  <div className="bg-purple-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3362">
                    MCS-150B
                  </div>
                  <div className="flex-1" data-id="element-3363">
                    <p className="font-semibold text-gray-900 group-hover:text-purple-600 transition-colors" data-id="element-3364">
                      Combined Motor Carrier Identification Report and Hazardous
                      Materials Permit Application
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3365">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-purple-600 ml-4 flex-shrink-0" size={20} data-id="element-3366" />
              </a>
            </div>
          </div>

          {/* Operating Authority (MC Number) Forms */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3367">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3368">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3369" />
              Operating Authority (MC Number)
            </h2>

            <div className="space-y-3" data-id="element-3370">
              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/op-1-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-blue-50 hover:bg-blue-100 border-2 border-blue-200 rounded-lg p-4 transition-colors group" data-id="element-3371">
                <div className="flex items-center flex-1" data-id="element-3372">
                  <div className="bg-blue-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3373">
                    OP-1
                  </div>
                  <div className="flex-1" data-id="element-3374">
                    <p className="font-semibold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-3375">
                      Application for Motor Property Carrier and Broker
                      Authority
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3376">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-blue-600 ml-4 flex-shrink-0" size={20} data-id="element-3377" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/OP-1(FF)-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-green-50 hover:bg-green-100 border-2 border-green-200 rounded-lg p-4 transition-colors group" data-id="element-3378">
                <div className="flex items-center flex-1" data-id="element-3379">
                  <div className="bg-green-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3380">
                    OP-1(FF)
                  </div>
                  <div className="flex-1" data-id="element-3381">
                    <p className="font-semibold text-gray-900 group-hover:text-green-600 transition-colors" data-id="element-3382">
                      Application for Freight Forwarder Authority
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3383">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-green-600 ml-4 flex-shrink-0" size={20} data-id="element-3384" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/OP-1(P)-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-purple-50 hover:bg-purple-100 border-2 border-purple-200 rounded-lg p-4 transition-colors group" data-id="element-3385">
                <div className="flex items-center flex-1" data-id="element-3386">
                  <div className="bg-purple-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3387">
                    OP-1(P)
                  </div>
                  <div className="flex-1" data-id="element-3388">
                    <p className="font-semibold text-gray-900 group-hover:text-purple-600 transition-colors" data-id="element-3389">
                      Application for Motor Passenger Carrier Authority
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3390">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-purple-600 ml-4 flex-shrink-0" size={20} data-id="element-3391" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/op-1mx.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-orange-50 hover:bg-orange-100 border-2 border-orange-200 rounded-lg p-4 transition-colors group" data-id="element-3392">
                <div className="flex items-center flex-1" data-id="element-3393">
                  <div className="bg-orange-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3394">
                    OP-1(MX)
                  </div>
                  <div className="flex-1" data-id="element-3395">
                    <p className="font-semibold text-gray-900 group-hover:text-orange-600 transition-colors" data-id="element-3396">
                      Application to Register Mexico-based Carriers
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-3397">
                      For Motor Carrier Authority to Operate Beyond U.S.
                      Municipalities and Commercial Zones on the U.S.-Mexico
                      Border
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3398">
                      <a href="http://www.fmcsa.dot.gov/documents/forms/op-1mx_instructions.pdf" className="text-orange-600 hover:underline" data-id="element-3399">
                        Instructions (PDF)
                      </a>{' '}
                      - Spanish instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-orange-600 ml-4 flex-shrink-0" size={20} data-id="element-3400" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/op-2.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-red-50 hover:bg-red-100 border-2 border-red-200 rounded-lg p-4 transition-colors group" data-id="element-3401">
                <div className="flex items-center flex-1" data-id="element-3402">
                  <div className="bg-red-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3403">
                    OP-2
                  </div>
                  <div className="flex-1" data-id="element-3404">
                    <p className="font-semibold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-3405">
                      Application for Mexican Certificate of Registration
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-3406">
                      For Foreign Motor Carriers and Foreign Motor Private
                      Carriers Under 49 U.S.C. 13902
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3407">
                      <a href="http://www.fmcsa.dot.gov/documents/forms/OP-2_Instructions.pdf" className="text-red-600 hover:underline" data-id="element-3408">
                        Instructions (PDF)
                      </a>{' '}
                      - Spanish instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-red-600 ml-4 flex-shrink-0" size={20} data-id="element-3409" />
              </a>
            </div>
          </div>

          {/* Process Agent Forms */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3410">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3411">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3412" />
              Process Agent
            </h2>

            <div className="space-y-3" data-id="element-3413">
              <a href="http://www.fmcsa.dot.gov/documents/boc.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-indigo-50 hover:bg-indigo-100 border-2 border-indigo-200 rounded-lg p-4 transition-colors group" data-id="element-3414">
                <div className="flex items-center flex-1" data-id="element-3415">
                  <div className="bg-indigo-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3416">
                    BOC-3
                  </div>
                  <div className="flex-1" data-id="element-3417">
                    <p className="font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors" data-id="element-3418">
                      Designation of Process Agents
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-3419">
                      Motor Carriers, Brokers and Freight Forwarders
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3420">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-indigo-600 ml-4 flex-shrink-0" size={20} data-id="element-3421" />
              </a>
            </div>
          </div>

          {/* Other Forms */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3422">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3423">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3424" />
              Other
            </h2>

            <div className="space-y-3" data-id="element-3425">
              <a href="http://www.fmcsa.dot.gov/documents/bmc-85.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-teal-50 hover:bg-teal-100 border-2 border-teal-200 rounded-lg p-4 transition-colors group" data-id="element-3426">
                <div className="flex items-center flex-1" data-id="element-3427">
                  <div className="bg-teal-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3428">
                    BMC-85
                  </div>
                  <div className="flex-1" data-id="element-3429">
                    <p className="font-semibold text-gray-900 group-hover:text-teal-600 transition-colors" data-id="element-3430">
                      Property Broker's Trust Fund Agreement
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-3431">
                      Under 49 U.S.C. 13906 or Notice of Cancellation of the
                      Agreement
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3432">
                      No instructions
                    </p>
                  </div>
                </div>
                <Download className="text-teal-600 ml-4 flex-shrink-0" size={20} data-id="element-3433" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/oce46.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-gray-50 hover:bg-gray-100 border-2 border-gray-200 rounded-lg p-4 transition-colors group" data-id="element-3434">
                <div className="flex items-center flex-1" data-id="element-3435">
                  <div className="bg-gray-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3436">
                    OCE-46
                  </div>
                  <div className="flex-1" data-id="element-3437">
                    <p className="font-semibold text-gray-900 group-hover:text-gray-600 transition-colors" data-id="element-3438">
                      Request for Revocation of Registration
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3439">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-gray-600 ml-4 flex-shrink-0" size={20} data-id="element-3440" />
              </a>
            </div>
          </div>

          {/* Commodity Regulation Information */}
          <div className="bg-yellow-50 border-2 border-yellow-500 rounded-lg shadow-md p-6 mb-8" data-id="element-3441">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-3442">
              Determining Regulated Commodities
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-3443">
              To determine if the company's commodities are regulated, refer to{' '}
              <a href="http://www.fmcsa.dot.gov/documents/adminrule.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline font-semibold inline-flex items-center" data-id="element-3444">
                Administration Ruling 119{' '}
                <ExternalLink className="ml-1" size={14} data-id="element-3445" />
              </a>
              .
            </p>
            <p className="text-gray-700" data-id="element-3446">
              <strong data-id="element-3447">
                If any commodity the company is transporting does not appear on
                these lists as exempt, then it is regulated.
              </strong>
            </p>
          </div>

          {/* Quick Reference Summary */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-3448">
            <h2 className="text-3xl font-bold mb-6" data-id="element-3449">Forms Quick Reference</h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-3450">
              <div data-id="element-3451">
                <h3 className="text-xl font-bold mb-3" data-id="element-3452">
                  USDOT Number (3 forms)
                </h3>
                <ul className="space-y-1 text-sm" data-id="element-3453">
                  <li data-id="element-3454">• MCS-150: Motor Carrier ID Report</li>
                  <li data-id="element-3455">• MCS-150A: Safety Certification</li>
                  <li data-id="element-3456">• MCS-150B: Combined Report + Hazmat</li>
                </ul>
              </div>

              <div data-id="element-3457">
                <h3 className="text-xl font-bold mb-3" data-id="element-3458">
                  Operating Authority (5 forms)
                </h3>
                <ul className="space-y-1 text-sm" data-id="element-3459">
                  <li data-id="element-3460">• OP-1: Property Carrier & Broker</li>
                  <li data-id="element-3461">• OP-1(FF): Freight Forwarder</li>
                  <li data-id="element-3462">• OP-1(P): Passenger Carrier</li>
                  <li data-id="element-3463">• OP-1(MX): Mexico-based Carriers</li>
                  <li data-id="element-3464">• OP-2: Mexican Certificate</li>
                </ul>
              </div>

              <div data-id="element-3465">
                <h3 className="text-xl font-bold mb-3" data-id="element-3466">
                  Process Agent (1 form)
                </h3>
                <ul className="space-y-1 text-sm" data-id="element-3467">
                  <li data-id="element-3468">• BOC-3: Designation of Process Agents</li>
                </ul>
              </div>

              <div data-id="element-3469">
                <h3 className="text-xl font-bold mb-3" data-id="element-3470">Other (2 forms)</h3>
                <ul className="space-y-1 text-sm" data-id="element-3471">
                  <li data-id="element-3472">• BMC-85: Broker's Trust Fund Agreement</li>
                  <li data-id="element-3473">• OCE-46: Revocation Request</li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-3474">
            <h2 className="text-3xl font-bold mb-4" data-id="element-3475">
              Need Help with Registration & Licensing?
            </h2>
            <p className="text-xl mb-6" data-id="element-3476">
              Expert guidance on FMCSA forms and compliance requirements
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-3477">
              <Phone className="mr-3" size={24} data-id="element-3478" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-3479">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}